import type { EditorSettings } from "$src/domain/designs/settings/EditorSettings";
import type { ISettingConfigurable } from "$src/domain/designs/settings/ISettingsConfigurable";
import type Konva from "konva";

export class View2DZoomHandler implements ISettingConfigurable {

    private stage :Konva.Stage;
    private editorSetting :EditorSettings;

    constructor(stage: Konva.Stage, editorSetting: EditorSettings) {
        this.stage = stage;
        this.editorSetting = editorSetting;

        this.stage.on('wheel', (e) => {

            var zoomSpeed = this.editorSetting.view2D.zoomSpeed;
            var minZoomValue = this.editorSetting.view2D.minZoomValue;
            var maxZoomValue = this.editorSetting.view2D.maxZoomValue;

            var oldScale = stage.scale()?.x ?? 1;
            var pointer = stage.getPointerPosition();

            if( pointer == null)
                return;

            var mousePointTo = {
            x: (pointer.x - stage.x()) / oldScale,
            y: (pointer.y - stage.y()) / oldScale,
            };

            let direction = e.evt.deltaY > 0 ? 1 : -1;

            if (e.evt.ctrlKey) {
                direction = -direction;
            }

            var newScale = direction < 0 ? oldScale * zoomSpeed : oldScale / zoomSpeed;

            if( newScale < minZoomValue )
                newScale = minZoomValue;

            if( newScale > maxZoomValue )
                newScale = maxZoomValue;

            stage.scale({ x: newScale, y: newScale });

            var newPos = {
            x: pointer.x - mousePointTo.x * newScale,
            y: pointer.y - mousePointTo.y * newScale,
            };
            stage.position(newPos);
        });
    }

    public setEditorSetting(editorSetting: EditorSettings) {
        this.editorSetting = editorSetting;
    }
}